module.exports = __webpack_public_path__ + "img/silver.c468527f.svg";